import { PLAN_CONFIDENCE_LEVELS, CONFIDENCE_SCORE_BAR_COUNT } from './constants';
import { getVariantColor } from './utils';
export default {
    name: 'ConfidenceBar',
    props: {
        confidenceLevel: {
            type: Object,
            required: true,
            validator: (value)=>Object.keys(PLAN_CONFIDENCE_LEVELS).includes(value.value)
        },
        ariaLabel: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        pillBgClass () {
            return getVariantColor(this.confidenceLevel.variant);
        },
        pillStyle () {
            const { barsToFill } = this.confidenceLevel;
            return {
                width: `${barsToFill / CONFIDENCE_SCORE_BAR_COUNT * 100}%`,
                backgroundColor: this.pillBgClass
            };
        }
    }
};
